import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { webFetchPartners } from 'actions/Partners'
import VisitSiplahView from 'components/publicPages/visitSiplah'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  webFetchPartners: bindActionCreators(webFetchPartners, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('mitraData', 'setMitraData', {
    isFetching: true,
    list: [],
  }),
  withHandlers({
    getList: props => async (params) => {
      const { setMitraData } = props
      try {
        const res = await props.webFetchPartners(params)
        setMitraData({
          isFetching: false,
          list: res,
        })
      } catch (err) {
        setMitraData({
          isFetching: false,
          list: [],
        })
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.getList()
    },
  }),
)(VisitSiplahView)
